import { Component, Host, h, Prop } from '@stencil/core';

/**
 * @slot - Designed to receive the text you want to display.
 */
@Component({
  tag: 'sy-text',
  styleUrls: ['scss/index.scss', 'scss/_tokens.scss'],
  shadow: true,
})
export class Text {
  private tagType = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    body: 'span',
    small: 'small',
    code: 'pre',
    lead: 'p',
  };

  /**
   * Sets the text type.
   */
  @Prop({ reflect: true }) type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'body' | 'small' | 'code' | 'lead' = 'body';

  /**
   * Sets the text weight to bold.
   */
  @Prop({ reflect: true }) bold = false;

  /**
   * Sets the text style to italic.
   */
  @Prop({ reflect: true }) italic = false;

  /**
   * Sets the font stretch to condensed.
   */
  @Prop({ reflect: true }) condensed = false;

  /**
   * Sets the text style to underline.
   */
  @Prop({ reflect: true }) underline = false;

  /**
   * Sets the text style to strikethrough.
   */
  @Prop({ reflect: true }) strikethrough = false;

  render() {
    const TextTag = this.tagType[this.type] || 'span';
    return (
      <Host>
        <TextTag
          class={{
            'sy-text': true,
            bold: this.bold,
            italic: this.italic,
            condensed: this.condensed,
            underline: this.underline,
            strikethrough: this.strikethrough,
          }}
        >
          <slot></slot>
        </TextTag>
      </Host>
    );
  }
}
